import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;


  public mfData? : object = {};
  public courts?;
  public users?;
  public timingSlots?;
  public bookingCategories?;
  public coaches?;
  public daysArray?:Array<{nameEn: string}> = [];
  reoccurDays: string;
  isUpdate: boolean = false;
  dbFunction?: string;
  bookingReoccurId: string;
  bookingFixedId: string;
  bookingCategoryId?: string;
  coachId?: string;
  userId: string;
  courtId: string;
  customerName: string;
  customerMobile: string;
  customerCountryCode: string;
  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
  timeSlot: string;
  notes: string;
  ccy: string;
  totalPrice: string;
  paidAmount: string;
  showInApp: string;
  status: string;
  public courtPrice;
  public courtPrice30min = 0.0;
  public courtPrice60min = 0.0;
  public courtPrice90min = 0.0;
  public courtPrice120min = 0.0;
  public facilityId = '';
  public isLoading = false;
  facilityCountryCode: string;

  public responseData?;
  public dbActiveData? = Array();
  classId: string;
  noOfPlayers: string;
  classPrice: string;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', {static: false}) public dangerModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private validationSrv : ValidationService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.facilityId = this.storageSrv.getFacilityId();
    this.userId = this.storageSrv.getUser();
    this.facilityCountryCode = this.storageSrv.getFacilityCountryCode();
    this.ccy = this.storageSrv.getFacilityCcy();

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.bookingReoccurId = this.mfData['id'];
      this.bookingCategoryId = this.mfData['bookingCategoryId'];
      this.bookingFixedId = this.mfData['bookingFixedId'];
      this.courtId = this.mfData['courtId'];
      this.coachId = this.mfData['coachId'];
      this.classPrice = this.mfData['classPrice'];
      this.noOfPlayers = this.mfData['noOfPlayers'];
      this.showInApp = this.mfData['showInApp'];
      this.customerName = this.mfData['customerName'];
      this.customerMobile = this.mfData['customerMobile'];
      this.customerCountryCode = this.mfData['customerCountryCode'];
      this.startTime = this.mfData['startTime'] != null ? new Date(this.mfData['start_date'].replace(/-/g, "/") + " " + this.mfData['startTime'].replace(/-/g, "/")) : this.mfData['startTime'];
      this.endTime = this.mfData['endTime'] != null ? new Date(this.mfData['end_date'].replace(/-/g, "/") + " " + this.mfData['endTime'].replace(/-/g, "/")) : this.mfData['endTime'];
      this.startDate = this.mfData['start_date'] != null ? new Date(this.mfData['start_date'].replace(/-/g, "/")) : this.mfData['start_date'];
      this.endDate = this.mfData['end_date'] != null ? new Date(this.mfData['end_date'].replace(/-/g, "/")) : this.mfData['end_date'];
      this.timeSlot = this.mfData['timeSlot'];
      this.reoccurDays = this.mfData['reoccurDays']?.split(',');
      this.ccy = this.storageSrv.getFacilityCcy();
      this.notes = this.mfData['notes'];
      this.totalPrice = this.mfData['totalPrice'];
      this.paidAmount = this.mfData['paidAmount'];
      this.status = this.mfData['status'];
    }
    else
    {
      this.courtId = '';
      this.bookingCategoryId = '';
      this.coachId = '';
      this.classPrice = '';
      this.ccy = this.storageSrv.getFacilityCcy();
      this.noOfPlayers = '';
      this.showInApp = '';
      this.customerName = '';
      this.customerMobile = '';
      this.customerCountryCode = this.facilityCountryCode;
      this.startTime = '';
      this.endTime = '';
      this.startDate = '';
      this.endDate = '';
      this.timeSlot = '';
      this.reoccurDays = '';
      this.notes = '';
      this.totalPrice = '';
      this.paidAmount = '';
      this.status = '';
    }
    //this.createForm();
  }


  ngOnInit(): void {
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        if (this.bookingFixedId != null) {
          await this.loadBookingFixedClass(this.bookingFixedId)
        }
        await this.loadCourts(this.facilityId);
        await this.loadCoaches();
        await this.loadBookingCategory(this.facilityId);
        await this.loadDays();
        await this.loadTimingSlots(this.facilityId);
        await this.createForm();
      });
    });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      courtId: [this.courtId, [Validators.required]],
      bookingCategoryId: [this.bookingCategoryId],
      coachId: [this.coachId],
      classPrice: [this.classPrice],
      noOfPlayers: [this.noOfPlayers],
      showInApp: [this.showInApp],
      customerName: [this.customerName, [Validators.required]],
      customerMobile: [this.customerMobile, [Validators.required]],
      customerCountryCode: [this.customerCountryCode, [Validators.required]],
      startTime: [this.startTime, [Validators.required]],
      endTime: [this.endTime, [Validators.required]],
      startDate: [this.startDate, [Validators.required]],
      endDate: [this.endDate, [Validators.required]],
      timeSlot: [this.timeSlot, [Validators.required]],
      reoccurDays: [this.reoccurDays, [Validators.required]],
      notes: [this.notes, [Validators.required]],
      ccy: {value: this.ccy, disabled: true},
      totalPrice: [this.totalPrice, [Validators.required]],
      paidAmount: [this.paidAmount, [Validators.required]],
      status: [this.status],
    }, { });
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}


saveBookingReoccur = () => {
  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    let formattedStartDate = (moment(new Date(this.f['startDate'].value))).format('YYYY-MM-DD');
    let formattedEndDate = (moment(new Date(this.f['endDate'].value))).format('YYYY-MM-DD');
    let formattedStartTime = new Date(this.f['startTime'].value).toTimeString().toString().substr(0, 8);
    var reoccurDays = this.f['reoccurDays'].value.toString();
    this.toolService.showConsoleLog(reoccurDays);
    const fields = {
      bookingReoccurId: this.mfData['id'],
      staffId: this.userId,
      facilityId: this.facilityId,
      bookingCategoryId: this.f['bookingCategoryId'].value,
      bookingFixedId: this.bookingFixedId,
      courtId: this.f['courtId'].value,
      coachId: this.f['coachId'].value,
      classPrice: this.f['classPrice'].value,
      noOfPlayers: this.f['noOfPlayers'].value,
      ccy: this.ccy,
      showInApp: this.f['showInApp'].value,
      customerName: this.f['customerName'].value,
      customerMobile: this.f['customerMobile'].value,
      customerCountryCode: this.f['customerCountryCode'].value,
      startTime: formattedStartTime,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      timeSlot: this.f['timeSlot'].value,
      reoccurDays: reoccurDays,
      notes: this.f['notes'].value,
      totalPrice: this.f['totalPrice'].value,
      paidAmount: this.f['paidAmount'].value,
      status: this.f['status'].value,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateBookingReoccur(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Booking Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.warning(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addBookingReoccur(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Booking Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.warning(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
}

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  loadCourts = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getCourts(facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.courts = this.dbActiveData;
        this.courts.offers = res.offers;
        this.courts.content = this.dbActiveData;
        //this.courts = res;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally();
    });
  }
  loadDays = () => {
      this.daysArray.push({
        nameEn: 'saturday'
      },
      {
        nameEn: 'sunday'
      },
      {
        nameEn: 'monday'
      },
      {
        nameEn: 'tuesday'
      },
      {
        nameEn: 'wednesday'
      },
      {
        nameEn: 'thursday'
      },
      {
        nameEn: 'friday'
      });
  }
  loadTimingSlots = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getTimingSlots(facilityId)
      .then(res => {
        this.timingSlots = res.content;
        if (this.timingSlots == ''){
          var defaultSlots:Array<{nameEn: string, timingInMinutes: number}> = [];
          defaultSlots.push({
            nameEn: '30 Minutes',
            timingInMinutes: 30
          });
          defaultSlots.push({
            nameEn: '1 Hour',
            timingInMinutes: 60
          });
          defaultSlots.push({
            nameEn: '1 Hour 30 Minutes',
            timingInMinutes: 90
          });
          defaultSlots.push({
            nameEn: '2 Hours',
            timingInMinutes: 120
          });
          defaultSlots.push({
            nameEn: '2 Hours 30 Minutes',
            timingInMinutes: 150
          });
          defaultSlots.push({
            nameEn: '3 Hours',
            timingInMinutes: 180
          });
          defaultSlots.push({
            nameEn: '3 Hours 30 Minutes',
            timingInMinutes: 210
          });
          defaultSlots.push({
            nameEn: '4 Hours',
            timingInMinutes: 240
          });
          defaultSlots.push({
            nameEn: '4 Hours 30 Minutes',
            timingInMinutes: 270
          });
          defaultSlots.push({
            nameEn: '5 Hours',
            timingInMinutes: 300
          });
          defaultSlots.push({
            nameEn: '5 Hours 30 Minutes',
            timingInMinutes: 330
          });
          defaultSlots.push({
            nameEn: '6 Hours',
            timingInMinutes: 360
          });
          this.timingSlots = defaultSlots;
        }
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.description, "Error");
      })
      .finally(() => this.isLoading = false
      );
    });
  }
  updateCourtPrices()
  {
    var startDateT = moment(new Date(this.simpleForm.controls['startDate'] ? this.f['startDate'].value : null)).format("YYYY-MM-DD");
    var startTime = moment(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : null).format("HH:mm:ss");

    var startTimeDT = new Date(startDateT + ' ' + startTime);
    var endTimeDT = new Date(startDateT + ' ' + startTime);

    const duration = this.simpleForm.controls['timeSlot'] != null ? this.f['timeSlot'].value : 0;
    let selectedCourtId = this.simpleForm.controls['courtId'] ? this.f['courtId'].value : 0;

    var isOffer = false;
    for (let offer of this.courts.offers)
    {
      var offerStartDate = new Date(offer.startDT.replace(/-/g, "/"));
      var offerEndDate = new Date(offer.endDT.replace(/-/g, "/"));

      // this.toolService.showConsoleLog("offerStartDateM" + offerStartDate);
      // this.toolService.showConsoleLog("offerEndDateM" + offerEndDate);
      // this.toolService.showConsoleLog("startDateM" + startTimeDT);
      // this.toolService.showConsoleLog("endDateM" + endTimeDT);

      var courtIds = offer.courtIds?.split(',');
      var reoccurOfferDays = offer.reoccurDays?.split(',');

      if (startTimeDT >= offerStartDate && startTimeDT <= offerEndDate && courtIds.indexOf(selectedCourtId) > -1)
      {

        // var bookingStartTime = moment(startTimeDT).format("HH:mm:ss");
        // var bookingEndTime = moment(endTimeDT).format("HH:mm:ss");
        // var offerStartTime = moment(new Date(offer["startTime"])).format("HH:mm:ss");
        // var offerEndTime = moment(new Date(offer["endTime"])).format("HH:mm:ss");

        var bookingStartDate = moment(startTimeDT).format("YYYY-MM-DD");
        var offerStartTime = moment(bookingStartDate + ' ' + offer["startTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");

        var bookingStartTime = moment(startTimeDT).format("YYYY-MM-DD HH:mm:ss");
        var bookingEndTime = moment(endTimeDT);
        
        var bookingEndDate = moment(endTimeDT).format("YYYY-MM-DD");

        this.toolService.showConsoleLog("bookingEndDate" + bookingEndDate);

        if (offer["endTimeOnly"] > offer["startTimeOnly"])
        {
          bookingEndDate = bookingStartDate;
        }

        var offerEndTime = moment(bookingEndDate + ' ' + offer["endTimeOnly"]).format("YYYY-MM-DD HH:mm:ss");
        
        // if (bookingEndTime.toString() == "00:00:00")
        // {
        //   bookingEndTime = '23:59:59';
        // }

        // this.toolService.showConsoleLog("offerStartTime" + offerStartTime);
        // this.toolService.showConsoleLog("offerEndTime" + offerEndTime);
        // this.toolService.showConsoleLog("bookingStartTime" + bookingStartTime);
        // this.toolService.showConsoleLog("bookingEndDate" + bookingEndDate);
        var selectedReoccurDay = moment(startTimeDT).format("dddd");
        
        if (bookingStartTime >= offerStartTime && bookingStartTime < offerEndTime && courtIds.indexOf(selectedCourtId) > -1 && reoccurOfferDays.indexOf(selectedReoccurDay.toLowerCase()) > -1)
        {
          this.toolService.showConsoleLog("isOffer");
          isOffer = true;
          this.courtPrice30min = parseFloat(offer["30minPrice"]);
          this.courtPrice60min = parseFloat(offer["60minPrice"]);
          this.courtPrice90min = parseFloat(offer["90minPrice"]);
          this.courtPrice120min = parseFloat(offer["120minPrice"]);
          break;
        }
        else
        {
          for (let court of this.courts.content)
          {
            if (court.id == selectedCourtId)
            {
              this.courtPrice30min = parseFloat(court["30minPrice"]);
              this.courtPrice60min = parseFloat(court["60minPrice"]);
              this.courtPrice90min = parseFloat(court["90minPrice"]);
              this.courtPrice120min = parseFloat(court["120minPrice"]);
              break;
            }
          }
        }
      }
      else
      {
        for (let court of this.courts.content)
        {
          if (court.id == selectedCourtId)
          {
            this.courtPrice30min = parseFloat(court["30minPrice"]);
            this.courtPrice60min = parseFloat(court["60minPrice"]);
            this.courtPrice90min = parseFloat(court["90minPrice"]);
            this.courtPrice120min = parseFloat(court["120minPrice"]);
            break;
          }
        }
      }
    }

    for (let court of this.courts.content)
    {
      if (court.id == selectedCourtId && !isOffer)
      {
        this.courtPrice30min = parseFloat(court["30minPrice"]);
        this.courtPrice60min = parseFloat(court["60minPrice"]);
        this.courtPrice90min = parseFloat(court["90minPrice"]);
        this.courtPrice120min = parseFloat(court["120minPrice"]);
      }
    }

    if (duration == 30)
    {
      this.courtPrice = this.courtPrice30min;
    }
    else if (duration == 60)
    {
      this.courtPrice = this.courtPrice60min;
    }
    else if (duration == 90)
    {
      this.courtPrice = this.courtPrice90min;
    }
    else if (duration == 120)
    {
      this.courtPrice = this.courtPrice120min;
    }
    else if (duration > 120)
    {
      var totalExtraTime = duration - 120;
      var totalExtraSlots = totalExtraTime / 30;
      var totalExtraPrice = totalExtraSlots * this.courtPrice30min;
      this.courtPrice = this.courtPrice120min + totalExtraPrice;
    }
    else
    {
      this.courtPrice = this.courtPrice120min;
    }

    this.simpleForm.patchValue({totalPrice: this.roundTo(this.courtPrice, 3), disabled:false});

  }
  public roundTo = function(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };
  loadBookingCategory = (facilityId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getBookingCategory(facilityId)
      .then(res => {
        this.responseData = Object.values(res);
        this.responseData[0].forEach(item => {
          if (item.status=='A')
          {
            const newObj = item;
            this.dbActiveData.push(newObj);
          }
        });
        this.bookingCategories = this.dbActiveData;
        this.bookingCategories.content = this.dbActiveData;
        //this.taxPercentage = this.courts.content.taxPercentage/100;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
  deleteBookingReoccur = (bookingReoccurId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        bookingReoccurId: bookingReoccurId
      };
      this.localInterfaceSrv.deleteBookingReoccur(bookingReoccurId,this.bookingFixedId)
      .then(async res => {
        resolve(res);
        this.toastr.success("Booking Removed", "Success");
        this.dangerModal.hide();
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });
      //   this.route.queryParams.subscribe(async params => {
      //     await this.loadBookingReoccur(this.facilityId);
      // });
        //window.location.reload()
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
        this.dangerModal.hide();
      })
      .finally(() => this.isLoading = false);
    });
  }
  loadCoaches = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.dbActiveData = Array();
      this.localInterfaceSrv.getCoachesByFacility()
      .then(res => {
        this.responseData = Object.values(res);
        this.coaches = res;
        //this.taxPercentage = this.courts.content.taxPercentage/100;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
  loadBookingFixedClass = (bookingFixedId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getBookingFixedClassTable(bookingFixedId)
      .then(res => {
        this.responseData = Object.values(res);
        this.coachId = res.content.coachId;
        this.noOfPlayers = res.content.noOfPlayers;
        this.showInApp = res.content.showInApp;
        this.classPrice = res.content.price;
        //this.taxPercentage = this.courts.content.taxPercentage/100;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }
}
